import dashboard from './dashboard';
import r2m from './r2m';
import admin from './admin';
import application from './application';
import forms from './forms';
import elements from './elements';
import samplePage from './sample-page';
import pages from './pages';
import utilities from './utilities';
import support from './support';
import other from './other';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [r2m, dashboard, admin, application, forms, elements, samplePage, pages, utilities, support, other]
};

export default menuItems;
